import { CommentFormType } from '@malesia/react-components/dist/src/components/Reservation/Summary/Admin';
import { LegacyFormConfig } from '@malesia/react-components/dist/src/hooks/useForm';
import { mapObject } from '@malesia/react-components/dist/src/utils/object';
import { useMemo } from 'react';
import { reservationNewPermissions } from '../../../permissions/adminPages/reservation/reservationNew';
import { UserPermissions } from '../../../permissions/userPermissions';
import { useUserPermissions } from '../../../permissions/useUserPermissions';

type Config = LegacyFormConfig<CommentFormType>;

const createConfig = (data: Partial<CommentFormType>): Config => ({
    comment: { initialValue: data.comment ?? '' },
});

const configurePermissions = (
    config: Config,
    userPermissions: UserPermissions,
): Config => {
    const createWithComment = userPermissions.has(reservationNewPermissions.createComment);

    const hiddenMap: Partial<Record<keyof Config, boolean>> = {
        comment: !createWithComment,
    };

    let result = config;

    result = mapObject(result, ([key, value]) => ({
        ...value,
        hidden: hiddenMap[key] || value.hidden,
    }));
    return result;
};

export const useCommentFormConfig = (data: Partial<CommentFormType>): Config => {
    const userPermissions = useUserPermissions();
    return useMemo<Config>(() => {
        const config = createConfig(data);
        return configurePermissions(config, userPermissions);
    }, [data, userPermissions]);
};
